import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

export default function AdminRoute() {
  const { user, authChecked } = useSelector((state) => state.auth);

  if (!authChecked) {
    return <p>Checking access...</p>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.roles?.includes("admin")) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
